import React, { useState } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import Fade from '@material-ui/core/Fade'
import VizSensor from 'react-visibility-sensor'

import styles from './Hero.module.sass'

const Hero = () => {
  let [active, setActive] = useState(false)
  return (
    <StaticQuery
      query={graphql`
        query Hero {
          heroBg: file(relativePath: { regex: "/heroBack.jpg/" }) {
            childImageSharp {
              fluid(maxWidth: 2200) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => (
        <div className={styles.heroContainer}>
          <BackgroundImage
            Tag="section"
            className={styles.heroImage}
            fluid={data.heroBg.childImageSharp.fluid}
            style={{ position: 'fixed' }}
          ></BackgroundImage>
          <VizSensor
            onChange={isVisible => {
              setActive(isVisible)
            }}
            partialVisibility
          >
            <Fade in={active} timeout={2500}>
              <div className={styles.heroContent}>
                <h1>fairies of tranquility</h1>
                <h2>dream, imagine & believe</h2>
              </div>
            </Fade>
          </VizSensor>
        </div>
      )}
    />
  )
}

export default Hero
